/* Download utilities */

(function (__module__) {
  'use strict';

  var logger = c2.logging.getLogger(__module__);


  function startDownload(url, filename) {
    var downloader = document.createElement('a');
    downloader.setAttribute('href', url);
    // this may not work in all browsers
    downloader.setAttribute('download', filename);
    downloader.classList.add('visually-hidden');
    // attach to body for FF click to work
    document.getElementsByTagName('body')[0]
      .insertAdjacentElement('beforeend', downloader);
    downloader.click();
    setTimeout(function() { downloader.remove(); }, 50);
  }


  /**
   * Trigger a file download containing `content`, suggested file name `filename`.
   * If mimeType is not specified, uses default "text/csv".
   */
  function startDownloadFromContent(content, filename, mimeType) {
    if (mimeType === undefined) {
      mimeType = 'text/csv';
    }
    logger.debug('filename:', filename, 'mimeType:', mimeType);

    var blob = new Blob([content], {type: mimeType});
    if (navigator.msSaveBlob) {
      // Special case for IE 11, of course.
      // https://msdn.microsoft.com/library/Hh772331
      navigator.msSaveBlob(blob, filename);
    } else {
      var url = URL.createObjectURL(blob);
      logger.debug('url:', url);
      startDownload(url, filename);
    }
  }

  function quoteValues(values) {
    return _.map(values, function(value) {
      return '"' + value + '"';
    });
  }

  function arrayToCSV(headers, rowsIn) {
    var rows = [quoteValues(headers).join(',')];

    _.forEach(rowsIn, function (row) {
      var cols = quoteValues(row);
      rows.push(cols.join(','));
    });

    return rows.join("\r\n");
  }


  // expose public functions
  c2[__module__] = {
    startDownload: startDownload,
    startDownloadFromContent: startDownloadFromContent,
    quoteValues: quoteValues,
    arrayToCSV: arrayToCSV
  };

})('downloads');
